<template>
  <l-form
    class="grid gap-3"
    @submit="submit"
  >
    <div class="grid gap-1">
      <l-autocomplete
        v-model="model"
        class="label:sr-only"
        placeholder="Select schools to compare"
        :disabled="!items.length"
        :items="items"
        label="Schools"
        multiple
        :max="4"
        :class="{
          'field:hidden': model.length >= 4
        }"
        :classes="{ tag: 'w-full flex items-center rounded-md border border-gray-300 dark:border-gray-800 justify-between text-left py-2 px-3 shadow-sm hover:bg-gray-400/10' }"
      />

      <p v-if="error" class="text-red font-medium">
        {{ error }}
      </p>
    </div>

    <l-button
      variant="primary"
      size="lg"
      class="mt-2"
      type="submit"
      :disabled="model.length < 2"
    >
      Compare schools
    </l-button>
  </l-form>
</template>

<script setup>
import LAutocomplete from "@/components/inputs/LAutocomplete.vue"
import LButton from "@/components/buttons/LButton.vue"
import LForm from "@/components/forms/LForm.vue"
import route from "ziggy-js"
import { computed, ref } from "vue"
import { useSchools } from "@/composables/useSchools"

const model = defineModel({ type: Array, default: () => [] })

const { schools } = useSchools()

const error = ref()

const items = computed(() => {
  return schools.map(item => ({ ...item, starred: item.in_list }))
})

const submit = (() => {
  if (!model.value.length) {
    error.value = "Please select a school."
  } else {
    error.value = null
    const slugs = model.value.map(item => item.slug)
    window.location.href = route("compare", slugs.sort().join("-vs-"))
  }
})
</script>
